import '!style-loader!css-loader!./Lowlight.css';
import Tooltip from '@platform-ui/tooltip-latest';
import cn from 'classnames';
import React, { RefObject, useEffect, useRef } from 'react';
import { createRoot } from 'react-dom/client';
import { useMarkedText } from '../../hooks/useMarkedText';
import styles from './Markdown.module.css';

type MarkdownProps = React.HTMLAttributes<HTMLDivElement> & { children: string | undefined };

const Markdown: React.FC<MarkdownProps> = ({ children, className, ...restProps }) => {
  const text = children?.toString() ?? '';

  const containerRef = useRef<HTMLDivElement>(null);

  const { parsedText } = useMarkedText({ text });

  useTooltipWrapper(containerRef, parsedText);

  return (
    <div
      ref={containerRef}
      className={cn(styles.root, className)}
      {...restProps}
      // parsedText <- useMarkedText <- textHtml <- DOMPurify
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: parsedText }}
    />
  );
};

const useTooltipWrapper = (containerRef: RefObject<HTMLDivElement>, parsedText: string) => {
  useEffect(() => {
    if (containerRef.current) {
      const elements = containerRef.current.querySelectorAll('[data-tooltip]');

      elements.forEach(element => {
        const title = element.getAttribute('data-tooltip');
        if (title) {
          const wrapper = document.createElement('span');
          const root = createRoot(wrapper);
          root.render(
            <Tooltip
              popoverContent={<Markdown>{title}</Markdown>}
              theme={'dark'}
              hoverDelay={250}
              closeOnPopoverClick={false}
              maxWidth={400}
              toBody
            >
              <span className={styles.tooltip}>{element.innerHTML}</span>
            </Tooltip>,
          );
          element.replaceWith(wrapper);
        }
      });
    }
  }, [containerRef, parsedText]);
};

export default Markdown;
